import React from "react";
import { CreditCard } from "lucide-react";
import { api } from "@/lib/api";

export const EMPTY_CARD = { kart_adi: "", kart_no: "", kullanici_adi: "", telefon: "", cep: "", email: "", kart_tipi: "Fiziki Kart", hediye: "Hayır", sube: "MERKEZ" };

export const loadPersonCard = async (pid) => {
  const r = await api.get("/payroll/meal-cards");
  return (r.data.rows || []).find((c) => c.personnel_id === pid) || null;
};

export const saveCard = (card, person) => {
  const body = {
    ...Object.fromEntries(Object.keys(EMPTY_CARD).map((k) => [k, String(card[k] ?? "").trim()])),
    personnel_id: person.id,
  };
  body.kart_adi = body.kart_adi || person.ad_soyad;
  body.cep = body.cep || person.telefon || "";
  return card.id ? api.put(`/payroll/meal-cards/${card.id}`, body) : api.post("/payroll/meal-cards", body);
};

const F = ({ label, children }) => (
  <label className="block"><span className="block text-[11px] font-semibold text-slate-600 mb-0.5">{label}</span>{children}</label>
);

export const MealCardFields = ({ card, setCard, adSoyad, telefon }) => {
  const set = (k) => (e) => setCard({ ...card, [k]: e.target.value });
  return (
    <div className="border border-teal-200 bg-teal-50/50 rounded-lg p-3 space-y-2" data-testid="meal-card-fields">
      <div className="text-xs font-bold text-teal-900 flex items-center gap-1.5"><CreditCard size={13} /> Yemek Kartı (Pluxee şablonu)
        <span className="font-normal text-teal-700">· kart no boşsa kart kaydı açılmaz</span></div>
      <div className="grid grid-cols-3 gap-2">
        <F label="Kart Adı"><input className="input" data-testid="card-kart-adi" placeholder={adSoyad || "Kart üzerindeki ad"} value={card.kart_adi} onChange={set("kart_adi")} /></F>
        <F label="Kart No"><input className="input font-mono-tab" data-testid="card-kart-no" value={card.kart_no} onChange={set("kart_no")} /></F>
        <F label="Kullanıcı Adı"><input className="input" data-testid="card-kullanici" value={card.kullanici_adi} onChange={set("kullanici_adi")} /></F>
        <F label="Telefon"><input className="input" data-testid="card-telefon" value={card.telefon} onChange={set("telefon")} /></F>
        <F label="Cep"><input className="input" data-testid="card-cep" placeholder={telefon || ""} value={card.cep} onChange={set("cep")} /></F>
        <F label="E-posta"><input className="input" type="email" data-testid="card-email" value={card.email} onChange={set("email")} /></F>
        <F label="Kart Tipi">
          <select className="input" data-testid="card-tipi" value={card.kart_tipi} onChange={set("kart_tipi")}><option>Fiziki Kart</option><option>Mobil Kart</option></select>
        </F>
        <F label="Hediye">
          <select className="input" data-testid="card-hediye" value={card.hediye} onChange={set("hediye")}><option>Hayır</option><option>Evet</option></select>
        </F>
        <F label="Şube"><input className="input" data-testid="card-sube" value={card.sube} onChange={set("sube")} /></F>
      </div>
      <div className="text-[10px] text-teal-800">Cep boş bırakılırsa personelin telefon numarası kullanılır.</div>
    </div>
  );
};
